<script setup>
import Button from '@components/global/button.vue'
import { formatDate } from '@utils/date'

defineProps(['item'])
</script>

<template>
	<div v-if="item" class="flex h-full w-full max-w-full flex-col gap-2 overflow-hidden rounded-[16px] bg-bg-dark p-4 outline outline-1 outline-offset-[-1px] outline-sf-purple-base md:h-[480px] md:flex-row">
		<div class="flex w-full max-w-[600px] flex-col items-start justify-between gap-8 p-10">
			<div class="flex w-full max-w-[352px] flex-col items-start gap-4">
				<div class="inline-flex items-center gap-2">
					<div class="flex items-center gap-3">
						<div class="h-1.5 w-1.5 bg-purple-300"></div>
						<div class="font-body text-body-sm font-medium uppercase leading-4 tracking-[0.12px] text-purple-300">
							{{ formatDate(item.published_at) }}
						</div>
					</div>
				</div>

				<h3 class="self-stretch font-heading text-h3 font-semibold uppercase leading-[32px] text-text-base">
					{{ item?.title }}
				</h3>
			</div>

			<Button class="btn-outline" :to="{ name: 'article', params: { slug: item.slug } }">read</Button>
		</div>

		<!-- Right column -->
		<div class="relative h-[380px] w-full overflow-hidden rounded-medium md:h-full">
			<img :src="item.image" alt="hero image" class="absolute inset-0 h-full w-full object-cover" />

			<!-- todo -->

			<img src="https://hennep.s3.amazonaws.com/above/images/articles/hero-bg.svg" class="absolute -top-[350px] left-0 h-[928px] w-[820px] rounded-[40px]" alt="" />
			<img src="https://hennep.s3.amazonaws.com/above/images/articles/sheep.svg" class="absolute bottom-[20%] left-[25%] h-[68px] w-[78px]" alt="" />
			<img class="absolute left-[20%] top-[0%] h-[120px] w-[40px]" src="https://hennep.s3.amazonaws.com/above/images/footer/ufo.svg" alt="Hennep" />

			<img class="absolute left-[30%] top-[5%]" src="https://hennep.s3.amazonaws.com/above/images/footer/star2.svg" alt="Hennep" />
			<img class="absolute left-[20%] top-[55%]" src="https://hennep.s3.amazonaws.com/above/images/footer/star2.svg" alt="Hennep" />

			<img class="absolute left-[25%] top-[7%]" src="https://hennep.s3.amazonaws.com/above/images/footer/star.svg" alt="Hennep" />

			<img class="absolute left-[35%] top-[6%]" src="https://hennep.s3.amazonaws.com/above/images/footer/star.svg" alt="Hennep" />

			<img class="absolute left-[23%] top-[60%]" src="https://hennep.s3.amazonaws.com/above/images/footer/star.svg" alt="Hennep" />
		</div>
	</div>
</template>

<style scoped></style>
